/**
 * Herlaadt Judge.me preview badges na dynamisch ingeladen content
 * (productaanbevelingen, recent bekeken, section rendering API).
 */
(function () {
  function refreshJudgeMeBadges() {
    if (typeof window.jdgm !== 'undefined' && typeof window.jdgm.customizeBadges === 'function') {
      window.jdgm.customizeBadges();
      return true;
    }

    if (typeof window.JDGM !== 'undefined' && typeof window.JDGM.loadBadges === 'function') {
      window.JDGM.loadBadges();
      return true;
    }

    return false;
  }

  function scheduleRefresh() {
    if (refreshJudgeMeBadges()) return;

    let attempts = 0;
    const timer = window.setInterval(() => {
      if (refreshJudgeMeBadges() || attempts >= 24) {
        window.clearInterval(timer);
      }
      attempts += 1;
    }, 250);
  }

  window.HabilleurJudgeMe = {
    refresh: scheduleRefresh,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleRefresh);
  } else {
    scheduleRefresh();
  }

  document.addEventListener('shopify:section:load', scheduleRefresh);

  document.addEventListener('DOMContentLoaded', () => {
    const observer = new MutationObserver((mutations) => {
      const hasNewBadge = mutations.some((mutation) =>
        [...mutation.addedNodes].some(
          (node) =>
            node.nodeType === 1 &&
            (node.matches?.('.jdgm-preview-badge, .habilleur-judgeme-badge') ||
              node.querySelector?.('.jdgm-preview-badge, .habilleur-judgeme-badge'))
        )
      );

      if (hasNewBadge) scheduleRefresh();
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });
})();
